const lazyImg = {
  install(app) {
    app.directive('lazyImg', (el, binding) => {
      // 这会在 `mounted` 和 `updated` 时都调用
      const observer = new IntersectionObserver(
        ([{ isIntersecting }]) => {
          if (isIntersecting) {
            observer.unobserve(el)
            el.src = binding.value
          }
        },
        {
          threshold: 0.01,
        }
      )
      observer.observe(el)
    })
  },
}

export default lazyImg
